import React, { Component } from 'react'

//import SignInModal from './SignInModal/index'
// import NotificationsModal from './NotificationsModal/index'
// import ChatModal from './ChatsModal/index'
import {EntriesModal} from './EntriesModal/index'
import {MoreModal} from './../modals/MoreModal'
import {TransactionsModal} from './TransactionsModal'
import {DreamTeamEntryCreationModal} from './DreamTeamEntryCreationModal/index'
import {SingleLeagueModal} from './../modals/SingleLeagueModal'
import {PredictionEntryCreationModal} from './PredictionEntryCreationModal/index'
import {SignInModal} from './SignInModal/index'
import {SponsorDetailsModal} from './../modals/SponsorDetailsModal'
import {NotificationsModal} from './NotificationsModal'
import AddCoinsModal from "./../modals/AddCoinsModal";


class CCModals extends Component {

    static propTypes = {}

    static defaultProps = {}

    constructor(props) {
        super(props)
    }

    render() {
        return (
            <div>
                <EntriesModal></EntriesModal>
                <SignInModal></SignInModal>
                <AddCoinsModal></AddCoinsModal>
                <PredictionEntryCreationModal></PredictionEntryCreationModal>
                <DreamTeamEntryCreationModal></DreamTeamEntryCreationModal>
                <TransactionsModal></TransactionsModal>
                <MoreModal></MoreModal>
                <SingleLeagueModal></SingleLeagueModal>
                <SponsorDetailsModal></SponsorDetailsModal>
                <NotificationsModal></NotificationsModal>




            </div>
        )
    }
}

export {CCModals}



// WEBPACK FOOTER //
// ./src/app/modals/CCModals.js